/* Delvia konum bileşeni — teslimat adımı ve Adreslerim AYNI kodu kullanır (28 Eyl).
   1) DelviaAranabilirSecim: gizli <select>'i "Ara..." kutulu listeye çevirir; <select> değerin
      tek kaynağı kalır, "Listede yok" ile elle yazılabilir.
   2) DelviaKonum: il/ilçe temanın assets/turkiye-il-ilce.json dosyasından, mahalle
      il başına assets/mahalle-XX.json dosyasından — dış servis (turkiyeapi) YOK.
      URL'ler snippets/delvia-konum-veri.liquid ile window.DELVIA_KONUM'a yazılır. */
(function () {
  if (window.DelviaKonum) return;
  function toTitleCase(str) {
    if (!str) return '';
    return str.trim().toLocaleLowerCase('tr-TR').split(/\s+/).map(word => {
      if (word.length === 0) return '';
      return word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1);
    }).join(' ');
  }

  // Aynı anda yalnız TEK liste açık (28 Eyl): telefon kodu + aranabilir listeler birlikte.
  function tumListeleriKapat(haric) {
    document.querySelectorAll('.searchable-select-dropdown.active').forEach(function (d) {
      if (d === haric) return;
      if (d._ss) d._ss.close(); else d.classList.remove('active');
    });
    document.querySelectorAll('[data-country-list].active').forEach(function (l) { if (l !== haric) l.classList.remove('active'); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') tumListeleriKapat(null); });

  class SearchableSelect {
    constructor(selectElement, options = {}) {
      this.select = selectElement;
      this.options = {
        placeholder: options.placeholder || 'Seçiniz...',
        noResultsText: options.noResultsText || 'Sonuç bulunamadı',
        manualEntryText: options.manualEntryText || 'Listede yok, kendim yazmak istiyorum',
        ...options
      };

      this.container = null;
      this.displayInput = null;
      this.dropdown = null;
      this.searchInput = null;
      this.optionsContainer = null;
      this.manualWrapper = null;
      this.manualInput = null;
      this.isOpen = false;
      this.highlightedIndex = -1;
      this.filteredOptions = [];

      this.init();
    }

    init() {
      // Create container
      this.container = document.createElement('div');
      this.container.className = 'searchable-select-container';
      this.select.parentNode.insertBefore(this.container, this.select);

      // Hide original select
      this.select.style.display = 'none';
      this.container.appendChild(this.select);

      // Create display input wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'searchable-select-input-wrapper';
      this.container.appendChild(wrapper);

      // Create display input (readonly, clicks open dropdown)
      this.displayInput = document.createElement('input');
      this.displayInput.type = 'text';
      this.displayInput.className = 'form-control searchable-select-display';
      this.displayInput.placeholder = this.options.placeholder;
      this.displayInput.readOnly = true;
      wrapper.appendChild(this.displayInput);

      // Gizli + required select Chrome'da formu SESSİZCE durdurur ("not focusable"): görünür alanı işaretle.
      this.select.addEventListener('invalid', (e) => {
        e.preventDefault();
        this.displayInput.style.borderColor = '#ef4444';
        this.displayInput.scrollIntoView({ block: 'center' });
        this.displayInput.focus();
      });
      this.select.addEventListener('change', () => { this.displayInput.style.borderColor = ''; });

      // Create caret icon
      const caret = document.createElement('span');
      caret.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>';
      caret.style.position = 'absolute';
      caret.style.right = '12px';
      caret.style.pointerEvents = 'none';
      wrapper.appendChild(caret);

      // Create dropdown
      this.dropdown = document.createElement('div');
      this.dropdown.className = 'searchable-select-dropdown';
      this.dropdown._ss = this;

      // Add search box to dropdown
      const searchWrapper = document.createElement('div');
      searchWrapper.className = 'searchable-select-search-wrapper';
      this.searchInput = document.createElement('input');
      this.searchInput.type = 'text';
      this.searchInput.className = 'searchable-select-search-input';
      this.searchInput.placeholder = this.options.searchPlaceholder || 'Ara…';
      this.searchInput.autocomplete = 'off';
      searchWrapper.appendChild(this.searchInput);
      this.dropdown.appendChild(searchWrapper);

      // Add options container
      this.optionsContainer = document.createElement('div');
      this.optionsContainer.className = 'searchable-select-options-container';
      this.dropdown.appendChild(this.optionsContainer);

      this.container.appendChild(this.dropdown);

      // Create manual input wrapper
      this.manualWrapper = document.createElement('div');
      this.manualWrapper.className = 'manual-input-wrapper';

      this.manualInput = document.createElement('input');
      this.manualInput.type = 'text';
      this.manualInput.className = 'form-control';
      this.manualInput.placeholder = 'Lütfen elle giriniz...';
      this.manualWrapper.appendChild(this.manualInput);

      const header = document.createElement('div');
      header.className = 'manual-input-header';
      header.innerHTML = '<span class="back-to-select">Listeye Geri Dön</span>';
      this.manualWrapper.appendChild(header);

      this.container.appendChild(this.manualWrapper);

      this.bindEvents();
      this.syncWithSelect();
    }

    bindEvents() {
      this.displayInput.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });

      this.searchInput.addEventListener('input', () => {
        this.renderOptions();
      });

      this.searchInput.addEventListener('click', (e) => e.stopPropagation());

      this.searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.highlightNext();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.highlightPrev();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          this.selectHighlighted();
        } else if (e.key === 'Escape') {
          this.close();
        }
      });

      document.addEventListener('click', (e) => {
        if (!this.container.contains(e.target)) {
          this.close();
        }
      });

      this.manualWrapper.querySelector('.back-to-select').addEventListener('click', () => {
        // User explicitly wants list mode — clear defaults so syncWithSelect won't auto-restore manual
        delete this.select.dataset.default;
        delete this.select.dataset.defaultCity;
        delete this.select.dataset.defaultAddress2;
        this._userExitedManual = true;
        this.disableManualEntry();
        // Open dropdown immediately so user sees the list
        setTimeout(() => this.open(), 50);
      });

      this.manualInput.addEventListener('input', () => {
        const start = this.manualInput.selectionStart;
        const end = this.manualInput.selectionEnd;
        const originalValue = this.manualInput.value;
        const formattedValue = toTitleCase(originalValue);

        if (originalValue !== formattedValue && originalValue.endsWith(' ')) {
           // Typing a space, don't format yet to avoid cursor jump
        } else if (originalValue !== formattedValue) {
          this.manualInput.value = formattedValue;
          this.manualInput.setSelectionRange(start, end);
        }
        this.updateSelectWithManualValue(this.manualInput.value);
      });

      this.manualInput.addEventListener('blur', () => {
        this.manualInput.value = toTitleCase(this.manualInput.value);
        this.updateSelectWithManualValue(this.manualInput.value);
      });

      // NOTE: Internal MutationObserver removed — caused infinite loop with disableManualEntry/back-to-select
      // syncWithSelect is called explicitly where needed (loadProvinces, change handlers).
    }

    syncWithSelect() {
      // Update disabled state from original select
      this.displayInput.disabled = this.select.disabled;
      this.manualInput.disabled = this.select.disabled;

      const options = Array.from(this.select.options);
      const isManualActive = this.manualWrapper.classList.contains('active');
      const userTypedManual = this.select.dataset.manualMode === '1';

      // Find selected option (skip placeholder "---")
      let selectedOption = options.find(opt => opt.selected && opt.value !== "" && opt.value !== "---")
        || options.find(opt => opt.value === this.select.value && opt.value !== "---" && opt.value !== "");

      // If we're in manual mode but a real option matches the manual value, switch to dropdown
      // (unless user explicitly typed manually originally)
      const manualOpt = options.find(opt => opt.dataset.manual === "true");
      if (isManualActive && manualOpt && !userTypedManual && !this._userExitedManual) {
        const manualVal = (manualOpt.value || '').toLocaleLowerCase('tr-TR');
        const realMatch = options.find(opt =>
          opt.dataset.manual !== "true" &&
          opt.value !== "" && opt.value !== "---" &&
          (opt.value.toLocaleLowerCase('tr-TR') === manualVal ||
           opt.text.toLocaleLowerCase('tr-TR') === manualVal)
        );
        if (realMatch) {
          manualOpt.remove();
          this.select.value = realMatch.value;
          this.displayInput.value = toTitleCase(realMatch.text);
          this.container.classList.add('has-value');
          this.disableManualEntry(true);
          return;
        }
      }

      // If we are in manual mode but the option was wiped from select (e.g. by parent script), re-add it
      if (isManualActive && !options.some(opt => opt.dataset.manual === "true")) {
        this.updateSelectWithManualValue(this.manualInput.value);
        return;
      }

      const isLoading = options.some(opt => opt.text.includes('Yükleniyor'));
      const hasManualOption = options.some(opt => opt.dataset.manual === "true");

      if (selectedOption && selectedOption.value !== "" && selectedOption.value !== "---" && selectedOption.text.trim() !== "---" && !selectedOption.text.includes('Yükleniyor')) {
        this.displayInput.value = toTitleCase(selectedOption.text);
        this.container.classList.add('has-value');

        if (selectedOption.dataset.manual === "true") {
          this.enableManualEntry(false); // Don't focus if syncing
        } else {
          this.disableManualEntry(true); // Return to select mode if a real option is selected
        }
      } else if (isLoading) {
        this.displayInput.value = 'Yükleniyor...';
        this.container.classList.add('has-value');
      } else if (isManualActive) {
        // Stay in manual mode if active
        this.container.classList.add('has-value');
      } else if (this._userExitedManual) {
        // User explicitly clicked "Listeye Geri Dön" — don't re-enable manual mode
        this.displayInput.value = '';
        this.container.classList.remove('has-value');
        this.disableManualEntry(true);
      } else {
        const defaultValue = this.select.dataset.default || this.select.dataset.defaultCity || this.select.dataset.defaultAddress2;
        const forceManual = this.select.dataset.manualMode === '1';
        if (defaultValue && defaultValue !== "") {
          if (forceManual) {
            // User originally typed manually — preserve manual mode
            this.manualInput.value = toTitleCase(defaultValue);
            this.displayInput.value = toTitleCase(defaultValue);
            this.container.classList.add('has-value');
            this.enableManualEntry(false);
            return;
          }
          const searchVal = defaultValue.trim().toLocaleLowerCase('tr-TR');
          const foundOption = options.find(opt =>
            opt.value.toLocaleLowerCase('tr-TR') === searchVal ||
            opt.text.toLocaleLowerCase('tr-TR') === searchVal
          );
          if (foundOption) {
            this.select.value = foundOption.value;
            this.displayInput.value = toTitleCase(foundOption.text);
            this.container.classList.add('has-value');
            this.disableManualEntry(true);
          } else {
            // Manual value from default
            this.displayInput.value = toTitleCase(defaultValue);
            this.container.classList.add('has-value');
            this.enableManualEntry(false);
          }
        } else if (!hasManualOption) {
          this.displayInput.value = '';
          this.container.classList.remove('has-value');
          this.disableManualEntry(true);
        }
      }
      this.renderOptions();
    }

    toggle() {
      if (this.isOpen) this.close();
      else this.open();
    }

    open() {
      if (this.select.disabled) return;
      if (this.manualWrapper.classList.contains('active')) return;

      tumListeleriKapat(this.dropdown);

      this.isOpen = true;
      this.dropdown.classList.add('active');
      this.searchInput.value = '';
      this.renderOptions();
      // focus preventScroll: aksi halde sayfa kendi basina ziplar (Patron 9 Eki)
      setTimeout(() => { this.searchInput.focus({ preventScroll: true }); this.gorunurYap(); }, 50);
    }

    // Acilan liste ekranin altinda kalmasin: gerektigi kadar kaydir, kutu yapiskan basligin arkasina kacmasin.
    gorunurYap() {
      if (!this.isOpen) return;
      var liste = this.dropdown.getBoundingClientRect();
      var kutu = this.container.getBoundingClientRect();
      var ust = 0;
      document.querySelectorAll('header, .header, sticky-header, header-component, .shopify-section-group-header-group').forEach(function (h) {
        var st = getComputedStyle(h), b = h.getBoundingClientRect();
        if ((st.position === 'sticky' || st.position === 'fixed') && b.bottom > 0) ust = Math.max(ust, b.bottom);
      });
      var gerek = liste.bottom - (window.innerHeight - 16);
      if (gerek <= 0) return;
      var kayma = Math.min(gerek, kutu.top - ust - 16);
      if (kayma <= 0) return;
      // Masaustunde sayfa .page-wrapper icinde kayiyor olabilir (Harmony 1920 px, olculdu): en yakin kayan ataya uygula.
      var k = this.container.parentElement;
      while (k && k !== document.body) { var o = getComputedStyle(k).overflowY; if ((o === 'auto' || o === 'scroll') && k.scrollHeight > k.clientHeight + 5) break; k = k.parentElement; }
      if (k && k !== document.body) k.scrollBy({ top: kayma, behavior: 'smooth' }); else window.scrollBy({ top: kayma, behavior: 'smooth' });
    }

    close() {
      this.isOpen = false;
      this.dropdown.classList.remove('active');
      this.highlightedIndex = -1;
    }

    renderOptions() {
      const term = this.searchInput.value.toLocaleLowerCase('tr-TR');
      const options = Array.from(this.select.options).filter(opt => 
        opt.value !== "" && 
        opt.dataset.manual !== "true" && 
        opt.text.trim() !== '---'
      );

      this.filteredOptions = options.filter(opt => 
        opt.text.toLocaleLowerCase('tr-TR').includes(term) || opt.value.toLocaleLowerCase('tr-TR').includes(term)
      );

      this.optionsContainer.innerHTML = '';

      if (this.filteredOptions.length > 0) {
        this.filteredOptions.forEach((opt, index) => {
          const div = document.createElement('div');
          div.className = 'searchable-select-option';
          if (opt.value === this.select.value) div.classList.add('selected');
          if (index === this.highlightedIndex) div.classList.add('highlighted');
          if (this.options.bayrak && /^[A-Za-z]{2}$/.test(opt.value)) {
            const img = document.createElement('img');
            img.src = bayrakUrl(opt.value.toLowerCase()); img.alt = ''; img.loading = 'lazy';
            img.className = 'searchable-select-bayrak';
            const ad = document.createElement('span');
            ad.textContent = toTitleCase(opt.text);
            div.appendChild(img); div.appendChild(ad);
          } else {
            div.textContent = toTitleCase(opt.text);
          }
          div.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectOption(opt);
          });
          this.optionsContainer.appendChild(div);
        });
      } else {
        const noResults = document.createElement('div');
        noResults.className = 'searchable-select-option no-results';
        noResults.textContent = this.options.noResultsText;
        this.optionsContainer.appendChild(noResults);
      }

      // Add "Manual Entry" option
      const manualDiv = document.createElement('div');
      manualDiv.className = 'searchable-select-option manual-entry';
      manualDiv.textContent = `+ ${this.options.manualEntryText}`;
      manualDiv.addEventListener('click', (e) => {
        e.stopPropagation();
        this.enableManualEntry(true);
      });
      this.optionsContainer.appendChild(manualDiv);
    }

    highlightNext() {
      if (this.filteredOptions.length === 0) return;
      this.highlightedIndex = (this.highlightedIndex + 1) % this.filteredOptions.length;
      this.renderOptions();
      this.scrollIntoView();
    }

    highlightPrev() {
      if (this.filteredOptions.length === 0) return;
      this.highlightedIndex = (this.highlightedIndex - 1 + this.filteredOptions.length) % this.filteredOptions.length;
      this.renderOptions();
      this.scrollIntoView();
    }

    selectHighlighted() {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredOptions.length) {
        this.selectOption(this.filteredOptions[this.highlightedIndex]);
      } else if (this.searchInput.value && this.filteredOptions.length === 0) {
        this.enableManualEntry(true);
      }
    }

    scrollIntoView() {
      const highlighted = this.optionsContainer.querySelector('.highlighted');
      if (highlighted) {
        highlighted.scrollIntoView({ block: 'nearest' });
      }
    }

    selectOption(opt) {
      this.select.value = opt.value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.displayInput.value = toTitleCase(opt.text);
      this.close();
      this.sonrakiniAc();
    }

    // Patron (8 Eki): il seçilince ilçe, ilçe seçilince mahalle listesi kendiliğinden açılsın.
    // Yalnız kullanıcı seçiminde çalışır; sonraki liste dolup açılana kadar en çok 5 sn bekler.
    sonrakiniAc() {
      var sira = { il: 'ilce', ilce: 'mahalle', 'address[province]': 'address[city]', 'address[city]': 'address[address2]' }[this.select.name];
      var form = this.select.form || this.select.closest('form, .dlv-ta, [data-adres-form]') || document;
      var sonraki = sira && form.querySelector('select[name="' + sira + '"]');
      if (!sonraki) return;
      var bas = Date.now();
      var dene = function () {
        var dd = sonraki.parentNode.querySelector('.searchable-select-dropdown');
        var ss = dd && dd._ss;
        if (ss && !sonraki.disabled && sonraki.options.length > 1) return ss.open();
        if (Date.now() - bas < 5000) setTimeout(dene, 150);
      };
      setTimeout(dene, 150);
    }

    enableManualEntry(shouldFocus = true) {
      this.close();
      this.wrapper = this.container.querySelector('.searchable-select-input-wrapper');
      this.wrapper.style.display = 'none';
      this.manualWrapper.classList.add('active');

      // Only take value if it's not a placeholder/empty
      let rawVal = this.manualInput.value || this.searchInput.value || this.displayInput.value;
      const placeholders = ['Şehir Seçiniz', 'İlçe Seçiniz', 'Mahalle Seçiniz', 'Seçiniz', 'Ara...', 'Yükleniyor...'];
      if (placeholders.some(p => rawVal.includes(p))) {
        rawVal = '';
      }

      const formattedVal = toTitleCase(rawVal);
      if (this.manualInput.value !== formattedVal) {
        this.manualInput.value = formattedVal;
      }

      this.updateSelectWithManualValue(formattedVal);
      if (shouldFocus) {
        setTimeout(() => this.manualInput.focus(), 50);
      }
    }

    disableManualEntry(keepValue = false) {
      this.manualWrapper.classList.remove('active');
      this.wrapper = this.container.querySelector('.searchable-select-input-wrapper');
      this.wrapper.style.display = 'flex';

      if (!keepValue) {
        const manualOpt = this.select.querySelector('option[data-manual="true"]');
        if (manualOpt) manualOpt.remove();

        this.select.value = '';
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.displayInput.value = '';
        this.manualInput.value = '';
        this.container.classList.remove('has-value');
      } else if (this.displayInput.value || this.select.value) {
        this.container.classList.add('has-value');
      }
    }

    updateSelectWithManualValue(val) {
      const titleVal = toTitleCase(val);
      let manualOpt = this.select.querySelector('option[data-manual="true"]');

      // No-op if nothing would change → prevents infinite loop with change dispatch
      if (manualOpt && manualOpt.value === titleVal && this.select.value === titleVal && manualOpt.selected) {
        return;
      }

      if (!manualOpt) {
        manualOpt = document.createElement('option');
        manualOpt.dataset.manual = "true";
        this.select.appendChild(manualOpt);
      }
      manualOpt.value = titleVal;
      manualOpt.text = titleVal;
      manualOpt.selected = true;
      this.select.value = titleVal;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  var K = window.DELVIA_KONUM || {};
  var ilSozu = null, mahalleSozu = {};
  function trk(s) { return (s || '').trim().toLocaleLowerCase('tr-TR'); }
  function jsonGetir(url) {
    var c = new AbortController();
    var t = setTimeout(function () { c.abort(); }, 8000);
    return fetch(url, { signal: c.signal }).then(function (r) {
      clearTimeout(t);
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  // [{k: plaka, a: il adı, i: [ilçeler]}]; hata olursa söz sıfırlanır, sonraki çağrı yeniden dener.
  function iller() {
    if (!ilSozu) ilSozu = jsonGetir(K.iller).catch(function (e) { ilSozu = null; throw e; });
    return ilSozu;
  }
  function ilBul(ad) {
    return iller().then(function (l) { return l.find(function (x) { return trk(x.a) === trk(ad); }) || null; });
  }
  // İlçenin mahalle listesi; dosya yoksa/gelmezse reddeder (çağıran elle yazmaya düşer).
  function mahalleler(ilAdi, ilceAdi) {
    return ilBul(ilAdi).then(function (il) {
      if (!il) throw new Error('il yok');
      var url = (K.mahalle || {})[il.k];
      if (!url) throw new Error('dosya yok');
      if (!mahalleSozu[il.k]) mahalleSozu[il.k] = jsonGetir(url).catch(function (e) { delete mahalleSozu[il.k]; throw e; });
      return mahalleSozu[il.k];
    }).then(function (m) {
      var anahtar = Object.keys(m).find(function (x) { return Array.isArray(m[x]) && trk(x) === trk(ilceAdi); });
      if (!anahtar || !m[anahtar].length) throw new Error('ilçe yok');
      return m[anahtar];
    });
  }
  function ilKodu(ad) {
    return ilBul(ad).then(function (p) { return p ? 'TR-' + String(p.k).padStart(2, '0') : ad; }, function () { return ad; });
  }

  var ULKELER = [
    { name: 'Türkiye', code: '+90', iso: 'tr' },
    { name: 'Afghanistan', code: '+93', iso: 'af' },
    { name: 'Albania', code: '+355', iso: 'al' },
    { name: 'Algeria', code: '+213', iso: 'dz' },
    { name: 'American Samoa', code: '+1-684', iso: 'as' },
    { name: 'Andorra', code: '+376', iso: 'ad' },
    { name: 'Angola', code: '+244', iso: 'ao' },
    { name: 'Anguilla', code: '+1-264', iso: 'ai' },
    { name: 'Antarctica', code: '+672', iso: 'aq' },
    { name: 'Antigua and Barbuda', code: '+1-268', iso: 'ag' },
    { name: 'Argentina', code: '+54', iso: 'ar' },
    { name: 'Armenia', code: '+374', iso: 'am' },
    { name: 'Aruba', code: '+297', iso: 'aw' },
    { name: 'Australia', code: '+61', iso: 'au' },
    { name: 'Austria', code: '+43', iso: 'at' },
    { name: 'Azerbaijan', code: '+994', iso: 'az' },
    { name: 'Bahamas', code: '+1-242', iso: 'bs' },
    { name: 'Bahrain', code: '+973', iso: 'bh' },
    { name: 'Bangladesh', code: '+880', iso: 'bd' },
    { name: 'Barbados', code: '+1-246', iso: 'bb' },
    { name: 'Belarus', code: '+375', iso: 'by' },
    { name: 'Belgium', code: '+32', iso: 'be' },
    { name: 'Belize', code: '+501', iso: 'bz' },
    { name: 'Benin', code: '+229', iso: 'bj' },
    { name: 'Bermuda', code: '+1-441', iso: 'bm' },
    { name: 'Bhutan', code: '+975', iso: 'bt' },
    { name: 'Bolivia', code: '+591', iso: 'bo' },
    { name: 'Bosnia and Herzegovina', code: '+387', iso: 'ba' },
    { name: 'Botswana', code: '+267', iso: 'bw' },
    { name: 'Brazil', code: '+55', iso: 'br' },
    { name: 'British Indian Ocean Territory', code: '+246', iso: 'io' },
    { name: 'British Virgin Islands', code: '+1-284', iso: 'vg' },
    { name: 'Brunei', code: '+673', iso: 'bn' },
    { name: 'Bulgaria', code: '+359', iso: 'bg' },
    { name: 'Burkina Faso', code: '+226', iso: 'bf' },
    { name: 'Burundi', code: '+257', iso: 'bi' },
    { name: 'Cambodia', code: '+855', iso: 'kh' },
    { name: 'Cameroon', code: '+237', iso: 'cm' },
    { name: 'Canada', code: '+1', iso: 'ca' },
    { name: 'Cape Verde', code: '+238', iso: 'cv' },
    { name: 'Cayman Islands', code: '+1-345', iso: 'ky' },
    { name: 'Central African Republic', code: '+236', iso: 'cf' },
    { name: 'Chad', code: '+235', iso: 'td' },
    { name: 'Chile', code: '+56', iso: 'cl' },
    { name: 'China', code: '+86', iso: 'cn' },
    { name: 'Christmas Island', code: '+61', iso: 'cx' },
    { name: 'Cocos Islands', code: '+61', iso: 'cc' },
    { name: 'Colombia', code: '+57', iso: 'co' },
    { name: 'Comoros', code: '+269', iso: 'km' },
    { name: 'Cook Islands', code: '+682', iso: 'ck' },
    { name: 'Costa Rica', code: '+506', iso: 'cr' },
    { name: 'Croatia', code: '+385', iso: 'hr' },
    { name: 'Cuba', code: '+53', iso: 'cu' },
    { name: 'Curacao', code: '+599', iso: 'cw' },
    { name: 'Cyprus', code: '+357', iso: 'cy' },
    { name: 'Czech Republic', code: '+420', iso: 'cz' },
    { name: 'Democratic Republic of the Congo', code: '+243', iso: 'cd' },
    { name: 'Denmark', code: '+45', iso: 'dk' },
    { name: 'Djibouti', code: '+253', iso: 'dj' },
    { name: 'Dominica', code: '+1-767', iso: 'dm' },
    { name: 'Dominican Republic', code: '+1-809, 1-829, 1-849', iso: 'do' },
    { name: 'East Timor', code: '+670', iso: 'tl' },
    { name: 'Ecuador', code: '+593', iso: 'ec' },
    { name: 'Egypt', code: '+20', iso: 'eg' },
    { name: 'El Salvador', code: '+503', iso: 'sv' },
    { name: 'Equatorial Guinea', code: '+240', iso: 'gq' },
    { name: 'Eritrea', code: '+291', iso: 'er' },
    { name: 'Estonia', code: '+372', iso: 'ee' },
    { name: 'Ethiopia', code: '+251', iso: 'et' },
    { name: 'Falkland Islands', code: '+500', iso: 'fk' },
    { name: 'Faroe Islands', code: '+298', iso: 'fo' },
    { name: 'Fiji', code: '+679', iso: 'fj' },
    { name: 'Finland', code: '+358', iso: 'fi' },
    { name: 'France', code: '+33', iso: 'fr' },
    { name: 'French Polynesia', code: '+689', iso: 'pf' },
    { name: 'Gabon', code: '+241', iso: 'ga' },
    { name: 'Gambia', code: '+220', iso: 'gm' },
    { name: 'Georgia', code: '+995', iso: 'ge' },
    { name: 'Germany', code: '+49', iso: 'de' },
    { name: 'Ghana', code: '+233', iso: 'gh' },
    { name: 'Gibraltar', code: '+350', iso: 'gi' },
    { name: 'Greece', code: '+30', iso: 'gr' },
    { name: 'Greenland', code: '+299', iso: 'gl' },
    { name: 'Grenada', code: '+1-473', iso: 'gd' },
    { name: 'Guam', code: '+1-671', iso: 'gu' },
    { name: 'Guatemala', code: '+502', iso: 'gt' },
    { name: 'Guernsey', code: '+44-1481', iso: 'gg' },
    { name: 'Guinea', code: '+224', iso: 'gn' },
    { name: 'Guinea-Bissau', code: '+245', iso: 'gw' },
    { name: 'Guyana', code: '+592', iso: 'gy' },
    { name: 'Haiti', code: '+509', iso: 'ht' },
    { name: 'Honduras', code: '+504', iso: 'hn' },
    { name: 'Hong Kong', code: '+852', iso: 'hk' },
    { name: 'Hungary', code: '+36', iso: 'hu' },
    { name: 'Iceland', code: '+354', iso: 'is' },
    { name: 'India', code: '+91', iso: 'in' },
    { name: 'Indonesia', code: '+62', iso: 'id' },
    { name: 'Iran', code: '+98', iso: 'ir' },
    { name: 'Iraq', code: '+964', iso: 'iq' },
    { name: 'Ireland', code: '+353', iso: 'ie' },
    { name: 'Isle of Man', code: '+44-1624', iso: 'im' },
    { name: 'Israel', code: '+972', iso: 'il' },
    { name: 'Italy', code: '+39', iso: 'it' },
    { name: 'Ivory Coast', code: '+225', iso: 'ci' },
    { name: 'Jamaica', code: '+1-876', iso: 'jm' },
    { name: 'Japan', code: '+81', iso: 'jp' },
    { name: 'Jersey', code: '+44-1534', iso: 'je' },
    { name: 'Jordan', code: '+962', iso: 'jo' },
    { name: 'Kazakhstan', code: '+7', iso: 'kz' },
    { name: 'Kenya', code: '+254', iso: 'ke' },
    { name: 'Kiribati', code: '+686', iso: 'ki' },
    { name: 'Kosovo', code: '+383', iso: 'xk' },
    { name: 'Kuwait', code: '+965', iso: 'kw' },
    { name: 'Kyrgyzstan', code: '+996', iso: 'kg' },
    { name: 'Laos', code: '+856', iso: 'la' },
    { name: 'Latvia', code: '+371', iso: 'lv' },
    { name: 'Lebanon', code: '+961', iso: 'lb' },
    { name: 'Lesotho', code: '+266', iso: 'ls' },
    { name: 'Liberia', code: '+231', iso: 'lr' },
    { name: 'Libya', code: '+218', iso: 'ly' },
    { name: 'Liechtenstein', code: '+423', iso: 'li' },
    { name: 'Lithuania', code: '+370', iso: 'lt' },
    { name: 'Luxembourg', code: '+352', iso: 'lu' },
    { name: 'Macau', code: '+853', iso: 'mo' },
    { name: 'Macedonia', code: '+389', iso: 'mk' },
    { name: 'Madagascar', code: '+261', iso: 'mg' },
    { name: 'Malawi', code: '+265', iso: 'mw' },
    { name: 'Malaysia', code: '+60', iso: 'my' },
    { name: 'Maldives', code: '+960', iso: 'mv' },
    { name: 'Mali', code: '+223', iso: 'ml' },
    { name: 'Malta', code: '+356', iso: 'mt' },
    { name: 'Marshall Islands', code: '+692', iso: 'mh' },
    { name: 'Mauritania', code: '+222', iso: 'mr' },
    { name: 'Mauritius', code: '+230', iso: 'mu' },
    { name: 'Mayotte', code: '+262', iso: 'yt' },
    { name: 'Mexico', code: '+52', iso: 'mx' },
    { name: 'Micronesia', code: '+691', iso: 'fm' },
    { name: 'Moldova', code: '+373', iso: 'md' },
    { name: 'Monaco', code: '+377', iso: 'mc' },
    { name: 'Mongolia', code: '+976', iso: 'mn' },
    { name: 'Montenegro', code: '+382', iso: 'me' },
    { name: 'Montserrat', code: '+1-664', iso: 'ms' },
    { name: 'Morocco', code: '+212', iso: 'ma' },
    { name: 'Mozambique', code: '+258', iso: 'mz' },
    { name: 'Myanmar', code: '+95', iso: 'mm' },
    { name: 'Namibia', code: '+264', iso: 'na' },
    { name: 'Nauru', code: '+674', iso: 'nr' },
    { name: 'Nepal', code: '+977', iso: 'np' },
    { name: 'Netherlands', code: '+31', iso: 'nl' },
    { name: 'Netherlands Antilles', code: '+599', iso: 'an' },
    { name: 'New Caledonia', code: '+687', iso: 'nc' },
    { name: 'New Zealand', code: '+64', iso: 'nz' },
    { name: 'Nicaragua', code: '+505', iso: 'ni' },
    { name: 'Niger', code: '+227', iso: 'ne' },
    { name: 'Nigeria', code: '+234', iso: 'ng' },
    { name: 'Niue', code: '+683', iso: 'nu' },
    { name: 'North Korea', code: '+850', iso: 'kp' },
    { name: 'Northern Mariana Islands', code: '+1-670', iso: 'mp' },
    { name: 'Norway', code: '+47', iso: 'no' },
    { name: 'Oman', code: '+968', iso: 'om' },
    { name: 'Pakistan', code: '+92', iso: 'pk' },
    { name: 'Palau', code: '+680', iso: 'pw' },
    { name: 'Palestine', code: '+970', iso: 'ps' },
    { name: 'Panama', code: '+507', iso: 'pa' },
    { name: 'Papua New Guinea', code: '+675', iso: 'pg' },
    { name: 'Paraguay', code: '+595', iso: 'py' },
    { name: 'Peru', code: '+51', iso: 'pe' },
    { name: 'Philippines', code: '+63', iso: 'ph' },
    { name: 'Pitcairn', code: '+64', iso: 'pn' },
    { name: 'Poland', code: '+48', iso: 'pl' },
    { name: 'Portugal', code: '+351', iso: 'pt' },
    { name: 'Puerto Rico', code: '+1-787, 1-939', iso: 'pr' },
    { name: 'Qatar', code: '+974', iso: 'qa' },
    { name: 'Republic of the Congo', code: '+242', iso: 'cg' },
    { name: 'Reunion', code: '+262', iso: 're' },
    { name: 'Romania', code: '+40', iso: 'ro' },
    { name: 'Russia', code: '+7', iso: 'ru' },
    { name: 'Rwanda', code: '+250', iso: 'rw' },
    { name: 'Saint Barthelemy', code: '+590', iso: 'bl' },
    { name: 'Saint Helena', code: '+290', iso: 'sh' },
    { name: 'Saint Kitts and Nevis', code: '+1-869', iso: 'kn' },
    { name: 'Saint Lucia', code: '+1-758', iso: 'lc' },
    { name: 'Saint Martin', code: '+590', iso: 'mf' },
    { name: 'Saint Pierre and Miquelon', code: '+508', iso: 'pm' },
    { name: 'Saint Vincent and the Grenadines', code: '+1-784', iso: 'vc' },
    { name: 'Samoa', code: '+685', iso: 'ws' },
    { name: 'San Marino', code: '+378', iso: 'sm' },
    { name: 'Sao Tome and Principe', code: '+239', iso: 'st' },
    { name: 'Saudi Arabia', code: '+966', iso: 'sa' },
    { name: 'Senegal', code: '+221', iso: 'sn' },
    { name: 'Serbia', code: '+381', iso: 'rs' },
    { name: 'Seychelles', code: '+248', iso: 'sc' },
    { name: 'Sierra Leone', code: '+232', iso: 'sl' },
    { name: 'Singapore', code: '+65', iso: 'sg' },
    { name: 'Sint Maarten', code: '+1-721', iso: 'sx' },
    { name: 'Slovakia', code: '+421', iso: 'sk' },
    { name: 'Slovenia', code: '+386', iso: 'si' },
    { name: 'Solomon Islands', code: '+677', iso: 'sb' },
    { name: 'Somalia', code: '+252', iso: 'so' },
    { name: 'South Africa', code: '+27', iso: 'za' },
    { name: 'South Korea', code: '+82', iso: 'kr' },
    { name: 'South Sudan', code: '+211', iso: 'ss' },
    { name: 'Spain', code: '+34', iso: 'es' },
    { name: 'Sri Lanka', code: '+94', iso: 'lk' },
    { name: 'Sudan', code: '+249', iso: 'sd' },
    { name: 'Suriname', code: '+597', iso: 'sr' },
    { name: 'Svalbard and Jan Mayen', code: '+47', iso: 'sj' },
    { name: 'Swaziland', code: '+268', iso: 'sz' },
    { name: 'Sweden', code: '+46', iso: 'se' },
    { name: 'Switzerland', code: '+41', iso: 'ch' },
    { name: 'Syria', code: '+963', iso: 'sy' },
    { name: 'Taiwan', code: '+886', iso: 'tw' },
    { name: 'Tajikistan', code: '+992', iso: 'tj' },
    { name: 'Tanzania', code: '+255', iso: 'tz' },
    { name: 'Thailand', code: '+66', iso: 'th' },
    { name: 'Togo', code: '+228', iso: 'tg' },
    { name: 'Tokelau', code: '+690', iso: 'tk' },
    { name: 'Tonga', code: '+676', iso: 'to' },
    { name: 'Trinidad and Tobago', code: '+1-868', iso: 'tt' },
    { name: 'Tunisia', code: '+216', iso: 'tn' },
    { name: 'Turkmenistan', code: '+993', iso: 'tm' },
    { name: 'Turks and Caicos Islands', code: '+1-649', iso: 'tc' },
    { name: 'Tuvalu', code: '+688', iso: 'tv' },
    { name: 'U.S. Virgin Islands', code: '+1-340', iso: 'vi' },
    { name: 'Uganda', code: '+256', iso: 'ug' },
    { name: 'Ukraine', code: '+380', iso: 'ua' },
    { name: 'United Arab Emirates', code: '+971', iso: 'ae' },
    { name: 'United Kingdom', code: '+44', iso: 'gb' },
    { name: 'United States', code: '+1', iso: 'us' },
    { name: 'Uruguay', code: '+598', iso: 'uy' },
    { name: 'Uzbekistan', code: '+998', iso: 'uz' },
    { name: 'Vanuatu', code: '+678', iso: 'vu' },
    { name: 'Vatican', code: '+379', iso: 'va' },
    { name: 'Venezuela', code: '+58', iso: 've' },
    { name: 'Vietnam', code: '+84', iso: 'vn' },
    { name: 'Wallis and Futuna', code: '+681', iso: 'wf' },
    { name: 'Western Sahara', code: '+212', iso: 'eh' },
    { name: 'Yemen', code: '+967', iso: 'ye' },
    { name: 'Zambia', code: '+260', iso: 'zm' },
    { name: 'Zimbabwe', code: '+263', iso: 'zw' }
  ];

  // Telefon ülke kodu seçicisi: .phone-input-wrapper içindeki [data-country-selector] bayrak düğmesi,
  // [data-country-list] aranabilir liste, [data-selected-flag] bayrak görseli. Seçimde onSec(ülke).
  // Ülke adları SİTENİN dilinde (<html lang>): tarayıcının Intl sözlüğü; desteklenmezse İngilizce ad.
  // Liste yerel ada göre sıralanır, Türkiye başta; arama yerel + İngilizce adla çalışır (28 Eyl).
  var dil = (document.documentElement.lang || 'tr').split('-')[0];
  var ulkeAdlari = null;
  try { ulkeAdlari = new Intl.DisplayNames([dil], { type: 'region' }); } catch (e) {}
  function yerelAd(c) {
    try { var a = ulkeAdlari && ulkeAdlari.of(c.iso.toUpperCase()); if (a && a.toUpperCase() !== c.iso.toUpperCase()) return a; } catch (e) {}
    return c.name;
  }
  var siraliUlkeler = null;
  function ulkeListesi() {
    if (!siraliUlkeler) {
      siraliUlkeler = ULKELER.map(function (c) { return { name: c.name, code: c.code, iso: c.iso, ad: yerelAd(c) }; })
        .sort(function (a, b) { return a.iso === 'tr' ? -1 : b.iso === 'tr' ? 1 : a.ad.localeCompare(b.ad, dil); });
    }
    return siraliUlkeler;
  }
  // Bayraklar TEMADA (assets/bayrak-<iso>.svg, flag-icons 7.5.0 — MIT, (c) 2013 Panayiotis Lipiridis).
  // Türkiye satır içi (ağ isteği yok); diğerleri listede loading=lazy ile yalnız görünen satırlarda iner (28 Eyl).
  var TR_BAYRAK = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='flag-icons-tr' viewBox='0 0 640 480'%3E %3Cg fill-rule='evenodd'%3E %3Cpath fill='%23e30a17' d='M0 0h640v480H0z'/%3E %3Cpath fill='%23fff' d='M407 247.5c0 66.2-54.6 119.9-122 119.9s-122-53.7-122-120 54.6-119.8 122-119.8 122 53.7 122 119.9'/%3E %3Cpath fill='%23e30a17' d='M413 247.5c0 53-43.6 95.9-97.5 95.9s-97.6-43-97.6-96 43.7-95.8 97.6-95.8 97.6 42.9 97.6 95.9z'/%3E %3Cpath fill='%23fff' d='m430.7 191.5-1 44.3-41.3 11.2 40.8 14.5-1 40.7 26.5-31.8 40.2 14-23.2-34.1 28.3-33.9-43.5 12-25.8-37z'/%3E %3C/g%3E %3C/svg%3E";
  function bayrakUrl(iso) { return iso === 'tr' ? TR_BAYRAK : (K.bayrakTaban || '') + 'bayrak-' + iso + '.svg'; }
  function telSecici(wrapper, onSec) {
    var selector = wrapper.querySelector('[data-country-selector]');
    var list = wrapper.querySelector('[data-country-list]');
    var flagImg = wrapper.querySelector('[data-selected-flag]');
    // Düğmede keskin SVG bayrak + yanında kod ("+90") — iki sayfada aynı (28 Eyl).
    var basIso = flagImg.getAttribute('data-iso') || 'tr';
    flagImg.src = bayrakUrl(basIso);
    var kodEl = selector.querySelector('[data-selected-code]');
    if (!kodEl) {
      kodEl = document.createElement('span');
      kodEl.className = 'dlv-tel-kod'; kodEl.setAttribute('data-selected-code', '');
      flagImg.insertAdjacentElement('afterend', kodEl);
    }
    var basUlke = ULKELER.find(function (x) { return x.iso === basIso; });
    kodEl.textContent = basUlke ? basUlke.code : '';
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    list.innerHTML = '<div class="country-search-wrapper"><input type="text" class="country-search-input" placeholder="Ülke ara veya kod yaz..."></div>'
      + '<div class="country-items-container">' + ulkeListesi().map(function (c) {
        return '<div class="country-item" data-code="' + esc(c.code) + '" data-iso="' + esc(c.iso) + '" data-name="' + esc((c.ad + ' ' + c.name).toLocaleLowerCase(dil)) + '">'
          + '<img src="' + esc(bayrakUrl(c.iso)) + '" alt="' + esc(c.ad) + '" width="28" height="20" loading="lazy" decoding="async">'
          + '<span class="country-name">' + esc(c.ad) + '</span><span class="country-code">' + esc(c.code) + '</span></div>';
      }).join('') + '</div>';
    var ara = list.querySelector('.country-search-input');
    var ogeler = list.querySelectorAll('.country-item');
    ara.addEventListener('input', function (e) {
      var term = e.target.value.toLocaleLowerCase(dil);
      ogeler.forEach(function (o) {
        o.style.display = (o.dataset.name.indexOf(term) > -1 || o.dataset.code.toLowerCase().indexOf(term) > -1) ? 'flex' : 'none';
      });
    });
    ara.addEventListener('click', function (e) { e.stopPropagation(); });
    selector.addEventListener('click', function (e) {
      e.stopPropagation();
      var acik = list.classList.contains('active');
      tumListeleriKapat(null);
      if (!acik) { list.classList.add('active'); setTimeout(function () { ara.focus(); }, 50); }
    });
    document.addEventListener('click', function (e) { if (!selector.contains(e.target)) list.classList.remove('active'); });
    ogeler.forEach(function (o) {
      o.addEventListener('click', function (e) {
        e.stopPropagation();
        var c = ULKELER.find(function (x) { return x.code === o.dataset.code && x.iso === o.dataset.iso; });
        flagImg.src = bayrakUrl(c.iso); flagImg.setAttribute('data-iso', c.iso);
        kodEl.textContent = c.code;
        flagImg.alt = c.iso.toUpperCase();
        list.classList.remove('active');
        onSec(c);
      });
    });
  }

  window.DelviaAranabilirSecim = SearchableSelect;
  window.DelviaKonum = { iller: iller, ilBul: ilBul, mahalleler: mahalleler, ilKodu: ilKodu, baslik: toTitleCase,
    ulkeler: ULKELER, telSecici: telSecici, bayrakUrl: bayrakUrl };
})();
